export default function ProductShow() {
  return (
    <section className="container px-6 py-12 mx-auto lg:py-16 items-center">
      <div className="mt-8 xl:-mx-6 xl:flex items-center">
        <div className="xl:w-1/2 xl:mx-6">
          <h3 className="font-serif text-3xl text-[#343D33] capitalize md:text-4xl lg:text-5xl py-8">
            Our Contributions & Works
          </h3>
          <img
            className="object-cover w-full h-96"
            src="/images/cont.jpg"
            alt=""
          />

          <h2 className="mt-6 font-serif text-3xl font-medium text-gray-700">
            In Corona virus
          </h2>

          <p className="mt-2 text-gray-500">
            Our Company has made several contributions for city of direDawa
            Administration to support the fight against corona virus pandemic.
          </p>
        </div>

        <div className="mt-8 space-y-8 xl:w-1/2 xl:mx-6 xl:mt-0">
          <div className="md:-mx-4 md:flex md:items-center">
            <img
              className="object-cover w-full h-56 md:h-48 md:mx-4 md:w-80 shrink-0"
              src="/images/product(6).png"
              alt=""
            />

            <div className="mt-6 md:mx-4 md:mt-0">
              <h2 className="font-serif text-2xl font-medium text-gray-700 ">
                Differnt kinds of products
              </h2>

              <p className="mt-2 text-gray-500">
                During the last five years, the company has strived to formulate
                & develop qualihJ personal care product, “LINA”.
              </p>
            </div>
          </div>

          <div className="md:-mx-4 md:flex md:items-center">
            <img
              className="object-cover w-full h-56 md:h-48 md:mx-4 md:w-80 shrink-0"
              src="/images/cont(1).png"
              alt=""
            />

            <div className="mt-6 md:mx-4 md:mt-0">
              <h2 className="font-serif text-2xl font-medium text-gray-700 ">
                Quality Products
              </h2>

              <p className="mt-2 text-gray-500">
                Qualification is major concern to HR and expertise people are
                our biggest asset which we sustain with great inspiration.
              </p>
            </div>
          </div>

          <div className="md:-mx-4 md:flex md:items-center">
            <img
              className="object-cover w-full h-56 md:h-48 md:mx-4 md:w-80 shrink-0"
              src="/images/lina-1.jpg"
              alt=""
            />

            <div className="mt-6 md:mx-4 md:mt-0">
              <h2 className="font-serif text-2xl font-medium text-gray-700 ">
                Product Composition
              </h2>

              <p className="mt-2 text-gray-500">
                “LINA”, registered brand name, has embraced astonishing product
                brands under its umbrella. These well-designed products of the
                company are:
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
